import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDInvalidateData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useInvalidateTSD = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TSDInvalidateData) => {
      const result = await apiClient.tsd.invalidate.mutation({ body: data });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storage', data.id] });
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Temporary storage declaration invalidation request sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the temporary storage declaration invalidation request!`);
    },
  });
};
